




























































































































































































































import VueOptions from '@utils/VueOptions'
import CalendarService from '@services/CalendarService'
import EditorContent from '@components/EditorContent'

settings =
  name: 'AudienceCreativeDisplay'

  resources:
    audience_creative:
      resourceName: 'audience_creative'
      slug: 'suppliers/:supplierId/audience_creatives/:audienceCreative.id'
      fetch: false
    dates:
      resourceName: 'calendar_date'
      slug: 'suppliers/:supplierId/audience_creatives/:audienceCreative.id/calendar_dates'
      params:
        quick_list: true
    spaces:
      resourceName: 'space'
      slug: 'suppliers/:supplierId/audience_creatives/:audienceCreative.id/spaces'
      params:
        quick_list: true

  vue:
    props: ['audienceCreative', 'options']

    components: {
      EditorContent,
    }

    data: ->
      checked: false

    computed:
      supplierId: -> @audienceCreative.supplier_id

      titlePattern: ->
        return '' unless @audienceCreative.title_pattern
        pattern = @audienceCreative.title_pattern
        pattern = pattern.replaceAll '{{', '<span class="py-1 px-2 rounded-full bg-recess text-white">'
        pattern = pattern.replaceAll '}}', '</span>'
        pattern

      availabilitiesTableData: ->
        { formatDate } = @$options.filters
        (@dates || []).map((date) =>
          { starts_on, repeats, rrule_string: rruleString, venues_info } = date
          id: date.id
          data: date
          date: CalendarService.formatCalendarDate({ date: starts_on, repeats, rruleString })
          venuesCount: venues_info.length
          venuesInfo: @formatVenuesInfo(venues_info)
        )

      inventoryTableData: ->
        (@spaces || []).map((space) =>
          id: space.id
          data: space
          segment: space.segment
          size: space.size
          type: space.type
          venuesCount: space.stats.availabilities_count
        )

      additionalTypes: ->
        types = @audienceCreative.types || []
        types.filter((item) => item isnt @audienceCreative.primary_type)

      primarySponsorSet: ->
        (@audienceCreative.sponsor_set || []).filter((s) => s.domain in @audienceCreative.sponsor_primary_domains)

      catex: ->
        Object.values(@audienceCreative.catex || {}).filter((c) => !c.prohibited)

      prohibitedCategories: ->
        Object.values(@audienceCreative.catex || {}).filter((c) => c.prohibited)

      catexTableData: ->
        @catex.map((category) =>
          id: category.category
          data: category
          category: category.category
          sponsors: category.sponsors
        )

      seasonsTableData: ->
        (@audienceCreative.seasons || []).map((season) =>
          year = dayjs().get('year')
          id: season.id
          data: season
          name: season.name
          starts_on: dayjs("#{year}-#{season.start_month}-#{season.start_day}").format('MMM DD')
          ends_on: dayjs("#{year}-#{season.end_month}-#{season.end_day}").format('MMM DD')
        )

      blockoutDatesTableData: ->
        (@audienceCreative.blockout_dates || []).map((date) =>
          id: date.id
          data: date
          name: date.name
          starts_on: dayjs(date.starts_on).format('MMM DD, YYYY')
          ends_on: dayjs(date.ends_on).format('MMM DD, YYYY')
        )

    methods:
      hiMarkAsChecked: ->
        @triggerResource 'audience_creative', 'mark_as_checked'
      onAudienceCreativeMarkAsChecked: ->
        @checked = true

      formatVenuesInfo: (venuesInfo) ->
        limit = 20
        data = venuesInfo
        data = data[0...limit] if venuesInfo.length > limit
        data = data.map((info) => "- #{info.venue_name} - #{info.city}, #{info.state}")
        data.push "and #{venuesInfo.length - limit} more" if venuesInfo.length > limit
        data.join('<br/>')

export default VueOptions.vue settings
